export default [
  [`Размер`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `42-44`, `46-50`, `52-54`, `56-60`, `60-64`],
  [`Полуобхват в груди, см`, `50`, `52`, `56`, `60`, `64`],
  [`Длина, см`, `64`, `66`, `68`, `70`, `74`]
];
